// eslint-disable-next-line react/prop-types
const ImageTrackingSceneInit = ({ targetSrc }) => {
  if (!targetSrc) return <></>;
  return (
    <a-scene
      mindar-image={`imageTargetSrc: ${targetSrc}; uiScanning: #instruction_screen;`}
      color-space="sRGB"
      renderer="colorManagement: true, physicallyCorrectLights"
      device-orientation-permission-ui="enabled: false"
      vr-mode-ui="enabled: false"
      xr-mode-ui="enabled: false"
      id="scene"
    >
      <a-assets></a-assets>

      <a-camera
        position="-0.1 0 -10"
        look-controls="enabled: false"
        cursor="fuse: false; rayOrigin: mouse;"
        raycaster="far: 10000; objects: .clickable"
      ></a-camera>
      <a-entity mindar-image-target="targetIndex: 0" id="marker"></a-entity>
    </a-scene>
  );
};

export default ImageTrackingSceneInit;
